import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchContainer({ packing_house_process_id, container_id }) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/move_package_group/${packing_house_process_id}/container/${container_id}`
    );
  },
  fetchPackingHouseProcess({packing_house_process_id}) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/move_package_group/${packing_house_process_id}/fetch_packing_house_process`
    );
  },
  move({packing_house_process_id, container_id, package_group_id, row_position, col_position}) {
    return RequesterV1.patch(`/packing_house/production/uniq_final_packing_list/move_package_group/${packing_house_process_id}/container/${container_id}/package_group/${package_group_id}/move`,
      { package_group: { row_position, col_position } })
  },
}
